module.exports = "<div class=\"sidebar\">\n  <!-- Search component -->\n  <searchbox></searchbox>\n\n  <!-- Categories component -->\n  <categories></categories>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/sidebar/sidebar.html
// module id = 556
// module chunks = 0